"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { IntegrationElementLevel } from '@membranehq/sdk';
import { IntegrationAppConnectionProvider } from '../../contexts/integration-app-connection-context.mjs';
import { IntegrationAppIntegrationProvider } from '../../contexts/integration-app-integration-context.mjs';
import { useIntegrationAppConnection } from '../../contexts/use-integration-app-connection.mjs';
import { useIntegrationAppIntegration } from '../../contexts/use-integration-app-integration.mjs';
import { IntegrationElementContext } from './use-integration-element.mjs';

const IntegrationElementProvider = ({
  children,
  integrationId: integrationIdfromParams,
  connectionId: connectionIdFromParams
}) => {
  const { connectionId: connectionIdFromContext } = useIntegrationAppConnection();
  const { integrationId: integrationIdFromContext } = useIntegrationAppIntegration();
  const integrationId = integrationIdfromParams ?? integrationIdFromContext;
  const connectionId = connectionIdFromParams ?? connectionIdFromContext;
  const level = connectionId ? IntegrationElementLevel.CONNECTION : integrationId ? IntegrationElementLevel.CONNECTOR : IntegrationElementLevel.UNIVERSAL;
  return /* @__PURE__ */ jsx(
    IntegrationElementContext.Provider,
    {
      value: {
        integrationId,
        connectionId,
        level
      },
      children: /* @__PURE__ */ jsx(IntegrationAppIntegrationProvider, { integrationId, children: /* @__PURE__ */ jsx(IntegrationAppConnectionProvider, { connectionId, children }) })
    }
  );
};

export { IntegrationElementProvider };
